// extracted by mini-css-extract-plugin
export var modal = "_47-0";